var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPoints(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.018 18.888C11.118 18.888 10.326 18.714 9.642 18.366C8.958 18.006 8.43 17.508 8.058 16.872C7.686 16.236 7.5 15.498 7.5 14.658V10.212C7.5 9.372 7.686 8.634 8.058 7.998C8.43 7.362 8.958 6.87 9.642 6.522C10.326 6.174 11.118 6 12.018 6C12.906 6 13.692 6.168 14.376 6.504C15.06 6.84 15.588 7.314 15.96 7.926C16.332 8.538 16.518 9.246 16.518 10.05C16.518 10.11 16.494 10.164 16.446 10.212C16.41 10.248 16.362 10.266 16.302 10.266L14.646 10.356C14.502 10.356 14.43 10.29 14.43 10.158C14.43 9.45 14.208 8.88 13.764 8.448C13.332 8.016 12.75 7.8 12.018 7.8C11.286 7.8 10.698 8.016 10.254 8.448C9.81 8.88 9.588 9.45 9.588 10.158V14.748C9.588 15.444 9.81 16.008 10.254 16.44C10.698 16.872 11.286 17.088 12.018 17.088C12.75 17.088 13.332 16.878 13.764 16.458C14.208 16.026 14.43 15.456 14.43 14.748C14.43 14.616 14.502 14.55 14.646 14.55L16.302 14.622C16.362 14.622 16.41 14.64 16.446 14.676C16.494 14.712 16.518 14.754 16.518 14.802C16.518 15.618 16.332 16.338 15.96 16.962C15.588 17.574 15.06 18.048 14.376 18.384C13.692 18.72 12.906 18.888 12.018 18.888Z",
    fill: "#007AFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPoints);
export default __webpack_public_path__ + "static/media/icon_points.418a201d98fbb87fd26b1dc24ba8c3d7.svg";
export { ForwardRef as ReactComponent };